<template>
  <div>
    <div class="content-left menuSide" v-if="$store.state.common.login">
      <div :class="[open ? 'open' : '', 'header-logo']">
        <a :href="'https://www.mondoconnex.com'" target="_blank">
          <img src="~../../assets/mondoconnex-menu-logo.svg" style="width: 150px; margin-top: 5px"/>
        </a>
      </div>
      <mu-drawer :open="open" :docked="docked" :overlay="docked" @close="close" style="padding-top: 65px;">

        <div style="position: relative;" class="mu-list-wrap">
          <mu-list toggle-nested @itemClick="docked ? '' : close()" style="padding-bottom: 355px;">
            <!--<mu-list-item :to="$settings.basicURL + '/dashboard' " title="Dashboard" >-->
            <!--<mu-icon slot="left" value="dashboard"/>-->
            <!--</mu-list-item>-->
            <mu-list-item class="menu-company-name">
              <mu-list-item-title>{{$store.state.common.companyName}}</mu-list-item-title>
            </mu-list-item>

            <mu-list-item class="menu-sub-title">
              <mu-list-item-title>Venue</mu-list-item-title>
            </mu-list-item>
            <mu-list-item button avatar
              :to="$settings.basicURL + '/venue/list' " id="side-nav-your-campaigns">
              <mu-list-item-action>
                <mu-icon value="business"/>
              </mu-list-item-action>
              <mu-list-item-title>Your Venues</mu-list-item-title>
            </mu-list-item>
            <mu-list-item v-if="$store.state.common.admin" :to="$settings.basicURL + '/venue/leads' " button avatar>
              <mu-list-item-action>
                <mu-icon value="toc"/>
              </mu-list-item-action>
              <mu-list-item-title>Contact Tracing Database</mu-list-item-title>
            </mu-list-item>
            <mu-list-item v-if="$store.state.common.admin" :to="$settings.basicURL + '/venue/marketing-list' " button avatar>
              <mu-list-item-action>
                <mu-icon value="contacts"/>
              </mu-list-item-action>
              <mu-list-item-title>Your Marketing List</mu-list-item-title>
            </mu-list-item>
            <mu-list-item v-if="$store.state.common.rootAdmin && ($store.state.common.enablePurchase || $store.state.common.enableMarketing)" :to="$settings.basicURL + '/invoices' " button avatar>
              <mu-list-item-action>
                <mu-icon value="payment"/>
              </mu-list-item-action>
              <mu-list-item-title>Invoices</mu-list-item-title>
            </mu-list-item>



            <mu-list-item class="menu-sub-title">
              <mu-list-item-title>Account</mu-list-item-title>
            </mu-list-item>
            <mu-list-item :to="$settings.basicURL + '/profile' " button avatar>
              <mu-list-item-action>
                <mu-icon value="account_box"/>
              </mu-list-item-action>
              <mu-list-item-title>Profile</mu-list-item-title>
            </mu-list-item>


          </mu-list>

          <div class="side-menu-bottom-wrap">
            <div class="list-line"></div>
            <!--<a href="javascript:void(0);" onclick="olark('api.box.expand')">-->
              <!--<mu-list-item title="Help" class="no-icon-item sub-item"></mu-list-item>-->
            <!--</a>-->
            <mu-list>
              <mu-list-item button :href="'https://www.mondoconnex.com/contact'" target="_blank" class="no-icon-item sub-item small-text" @click="mobileClose">
                <mu-list-item-title>Contact Us</mu-list-item-title>
              </mu-list-item>
<!--              <template v-if="$store.state.system.reseller !== 2">-->
<!--                <div class="list-line"></div>-->
<!--                <mu-list-item :to="$settings.basicURL + '/registrationterms' " class="no-icon-item sub-item small-text" @click="mobileClose">-->
<!--                  <mu-list-item-title>Registration Terms</mu-list-item-title>-->
<!--                </mu-list-item>-->
<!--                <mu-list-item :to="$settings.basicURL + '/portaltermsofuse' " class="no-icon-item sub-item small-text" @click="mobileClose">-->
<!--                  <mu-list-item-title>Portal Terms of Use</mu-list-item-title>-->
<!--                </mu-list-item>-->
<!--                <mu-list-item :to="$settings.basicURL + '/privacystatement' " class="no-icon-item sub-item small-text" style="margin-bottom: 10px;" @click="mobileClose">-->
<!--                  <mu-list-item-title>Privacy Statement</mu-list-item-title>-->
<!--                </mu-list-item>-->
<!--              </template>-->
              <mu-list-item @click="logout" button avatar class="mobile-show" style="padding: 10px 0;border-top: 1px solid #3c3c3c;">
                <mu-list-item-action>
                  <mu-icon value="input"/>
                </mu-list-item-action>
                <mu-list-item-title>Log out</mu-list-item-title>
              </mu-list-item>
            </mu-list>
            <div class="side-menu-bottom-text-content">
              MondoConneX © 2020<br>v2.0
            </div>
          </div>
        </div>


      </mu-drawer>

    </div>

    <div class="content-left menuSide" v-if="!$store.state.common.login">
      <mu-drawer :open="open" :docked="docked" :overlay="docked" @close="close">
        <mu-appbar title="" class="mobile-menu-appbar">
          <a :href="'https://www.mondoconnex.com'" target="_blank">
            <img src="~../../assets/MondoConneX_Logo.png" style="width: 100px; margin-top: 27px"/>
          </a>
        </mu-appbar>

        <mu-list  @itemClick="docked ? '' : close()">
          <!--<mu-list-item :to="$settings.basicURL + '/dashboard' " title="Dashboard" >-->
          <!--<mu-icon slot="left" value="dashboard"/>-->
          <!--</mu-list-item>-->

          <mu-list-item button avatar :to="$settings.basicURL + '/registration' ">
            <mu-list-item-action>
              <mu-icon value="assignment"/>
            </mu-list-item-action>
            <mu-list-item-title>Registration</mu-list-item-title>
          </mu-list-item>

          <mu-list-item :to="$settings.basicURL + '/login' " button avatar>
            <mu-list-item-action>
              <mu-icon value="assignment_ind"/>
            </mu-list-item-action>
            <mu-list-item-title>Login</mu-list-item-title>
          </mu-list-item>

        </mu-list>
        <div class="side-menu-bottom-wrap">
          <div class="side-menu-bottom-text-content">
            MondoConneX © 2020<br>v1.0
          </div>
        </div>
      </mu-drawer>

    </div>
  </div>
</template>
<script>
  import MuSubHeader from 'muse-ui/src/SubHeader/SubHeader'
  import MuListItem from 'muse-ui/es5/List/ListItem'
  import MuList from 'muse-ui/es5/List/List'

  export default {
    components: {
      MuList,
      MuListItem,
      MuSubHeader},
    props: {
      open: {
        type: Boolean,
        default: true
      },
      docked: {
        type: Boolean,
        default: false
      }
    },

    created () {
      console.log('init menu')
      this.checkOpenCategory()
    },

    data () {
      return {
        campaignOpen: false,
        accountOpen: false
      }
    },

    watch: {
      '$route.path': function (value) {
        this.checkOpenCategory()
      }
    },

    methods: {
      close () {
        this.$emit('close')
      },
      logout () {
        this.$emit('logout')
      },
      checkOpenCategory () {
        if (this.$route.path.indexOf('/venue/') >= 0) {
          this.campaignOpen = true
          this.accountOpen = false
        } else if (this.$route.path.indexOf('/account/') >= 0) {
          this.accountOpen = true
          this.campaignOpen = false
        } else {
          this.accountOpen = false
          this.campaignOpen = false
        }
      },
      mobileClose () {
        if (window.innerWidth <= 800) {
          this.$emit('close')
        }
      }
    }
  }
</script>


<style lang="scss">
  .menuSide{
    .header-logo{
      position: fixed;
      top: 0;
      left: 0;
      z-index: 99;
      width: 100%;
      max-width: 256px;
      /*background: rgb(35, 35, 35);*/
      border-bottom: 1px solid;
      height: 64px;
      text-align: left;
      padding: 0 20px;
      -webkit-transition: all .45s cubic-bezier(.23,1,.32,1);
      transition: all .45s cubic-bezier(.23,1,.32,1);
      -webkit-overflow-scrolling: touch;
      -webkit-transition-property: visibility,-webkit-transform;
      transition-property: visibility,-webkit-transform;
      transition-property: transform,visibility;
      transition-property: transform,visibility,-webkit-transform;

      -webkit-transition-duration: .45s;
      transition-duration: .45s;
      -webkit-transform: translate3d(-100%,0,0);
      transform: translate3d(-100%,0,0);
      visibility: hidden;
      z-index: 4;
      &.open{
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        visibility: visible;
        z-index: 20141242;
      }
    }
    .mu-drawer{
      background: #002855;
      .mu-list-wrap{
        min-height: 100%
      }
      .mu-item{
        color: #9e9e9e;
        min-height: 41px;
        height: 41px;
        padding: 12px;
        padding-left: 18px;

        .mu-item-action {
          color: #9e9e9e;
          min-width: 30px;
        }
        .mu-item-title{
          text-align: left;
        }

        &:hover{
          .mu-item-title-row, .mu-icon{
            color: #b8b8b8;
          }
        }
      }
      .mu-item-wrapper{
        border-left: 4px solid transparent;
      }

      .mondo-icon {
        /** same as #9e9e9e **/
        filter: invert(67%) sepia(0%) saturate(100%) hue-rotate(180deg) brightness(97%) contrast(82%);
      }

      .router-link-active{
        .mondo-icon {
          /** same as #2AD2C9 **/
          filter: invert(78%) sepia(100%) saturate(387%) hue-rotate(101deg) brightness(87%) contrast(88%);
        }
        .mu-icon{
          color: #2AD2C9;
        }
        .mu-item-left, .mu-item-title-row, .mu-item-title{
          color: #fff;
        }
        .mu-item:hover{
          .mu-item-left, .mu-item-title-row, .mu-item-title{
            color: #fff;
          }
        }
        border-left: 4px solid #002855;
      }
      .sub-item{
        .router-link-active{
          .mu-item-left, .mu-item-title-row{
            color: #002855;
          }
          .mu-item:hover{
            .mu-item-left, .mu-item-title-row{
              color: #002855;
            }
          }
          border-left: 4px solid transparent;
        }
        &.small-text{
          .mu-item-title{
            font-size: 12px!important;
          }
        }
      }
      .custom-active{
        a{
          .mu-item-left, .mu-item-title-row{
            color: #fff;
          }
          .mu-item:hover{
            .mu-item-left, .mu-item-title-row{
              color: #fff;
            }
          }
          border-left: 4px solid #002855;
        }
      }
      .no-icon-item{
        .mu-item {
          padding-left: 15px!important;
          .mu-item-title{
            font-size: 13px!important;
          }
        }
      }
      .list-line{
        width: 100%;
        height: 1px;
        background: #404040;
      }
    }
    .side-menu-bottom-wrap{
      position: absolute;
      left: 0;
      bottom: 0;
      color: #6f6f6f;
      width: 100%;
      .side-menu-bottom-text-content{
        padding: 20px;
        text-align: left;
        border-top: 1px solid #3c3c3c;
      }
    }
    .menu-company-name{
      .mu-item{
        padding: 12px 0 12px 18px;
        .mu-item-title{
          font-size: 14px;
          color: #ffffff;
        }
      }

    }
    .menu-sub-title{
      margin-top: 10px;
      .mu-item{
        padding: 12px 0 12px 18px;
        .mu-item-title{
          font-size: 14px;
          font-weight: 500;
          color: #b8b8b8;
          font-family: Helvetica, Arial, sans-serif !important;
        }
      }

    }
  }

  .mobile-menu-appbar {
    background: #002855;
    text-align: left;
    padding-left: 13px;
    border-bottom: 1px solid;
  }

  @media  (max-width: 479px) {
    .menuSide{
      .header-logo{
        height: 56px;
        img {
          margin-top: 5px!important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// asider.vue?4ed8dc82